const createAnnouncementsApi = ({ announcements }) => {
  return {
    announcements: {
      dispose: announcements.dispose,
    },
  }
}

const announcementApiDefinition = {
  id: 'announcementsApi',
  type: 'api',
  factory: createAnnouncementsApi,
  dependencies: ['announcements'],
}

export default announcementApiDefinition
